<template>
  <div class="leftTreeBody">
    <div id="leftTreeSelect">
      <a-row style="margin-bottom: 8px; align-items: canter" type="flex">
        <a-col style="text-align: right; font-size: 15px" :span="8">
          <ellipsis :length="10" tooltip>时间范围</ellipsis>：
        </a-col>
        <a-col :span="16">
          <a-range-picker
            :allowClear="false"
            :value="[moment(filter.startTime), moment(filter.endTime)]"
            :format="'YYYY-MM-DD'"
            @change="rangeChange"
          />
        </a-col>
      </a-row>
      <a-row style="margin-bottom: 8px; align-items: canter" type="flex">
        <a-col style="text-align: right; font-size: 15px" :span="8">
          <ellipsis :length="10" tooltip>设备类型</ellipsis>：
        </a-col>
        <a-col :span="16">
          <a-select
            style="width: 100%"
            show-search
            optionFilterProp="children"
            mode="multiple"
            :maxTagCount="1"
            :value="filter.deviceTypeId"
            placeholder="请选择设备类型"
            @change="selectType"
          >
            <a-select-option v-for="(item, index) in deviceTypes" :key="index" :value="item.key">
              {{ item.value }}
            </a-select-option>
          </a-select>
        </a-col>
      </a-row>
      <a-row style="margin-bottom: 8px; align-items: canter" type="flex">
        <a-col style="text-align: right; font-size: 15px" :span="8">
          <ellipsis :length="12" tooltip>变化过滤阈值</ellipsis>：
        </a-col>
        <a-col :span="16">
          <a-input-number
            style="width: 100%"
            :min="0"
            :max="100"
            v-model="filter.threshold"
            placeholder="请输入变化过滤阈值 %"
          />
        </a-col>
      </a-row>
    </div>
    <div class="mdc-left-tree" style="height: calc(100% - 165px)">
      <a-tree
          v-if="treeData.length>0"
          :tree-data="treeData"
          :defaultExpandedKeys="expandedKeys"
          :defaultCheckedKeys="expandedKeys"
          checkable
          :replaceFields="{children:'children', title: 'name', key: 'code'}"
          @check="checkTree"
      />
    </div>
    <div class="button-save">
      <!-- <a-button type="default" @click="hanldeOutPut()">{{ $t('page_time_analysis_output') }}</a-button> -->
      <a-button style="margin-left: 8px" type="primary" @click="handelSearch()">
        {{ $t('page_time_analysis_search') }}
      </a-button>
    </div>
  </div>
</template>

<script>
import { DeviceTypeServiceProxy } from '@/service-proxies/app-v2/workStation.service-proxies'
import { RegionServiceProxy } from '@/service-proxies/app-v2/system.service-proxies'
import { CustomerServiceProxy } from '@/service-proxies/app-v2/client.service-proxies'
import {CustomerServiceProxy as mccsp } from "@/service-proxies/app-v2/masterlink-cps-client.service-proxies"

const rsp = new RegionServiceProxy()
const csp = new CustomerServiceProxy()
const dtsp = new DeviceTypeServiceProxy()
const api = new mccsp();
import { getTenantInfo } from '@/utils/auth'
import moment from 'moment'
import dayjs from 'dayjs'

export default {
  name: 'left-tree',
  data() {
    return {
      filter: {
        deviceTypeId: [],
        issueType: '0',
        startTime: dayjs().format('YYYY-MM-DD'),
        endTime: dayjs().format('YYYY-MM-DD'),
        threshold: '',
        workStationName: '',
        customerIdList: [],
      },
      deviceTypes: [],
      clientHeight: 0,
      treeData: [],
      expandedKeys: ['00-00'],
    }
  },
  created() {
    this.filter.deviceTypeId = []
    this.getTypeList()
    this.getTreeList()
  },
  methods: {
    moment,
    selectType(value) {
      this.filter.deviceTypeId = value
    },
    handelSearch() {
      if(!this.filter.customerIdList.length) {
       return this.$message.warning(this.$t('page_ops_work_record_customer_required'))
      }
      const value = {
        deviceTypeIdList: this.filter.deviceTypeId,
        startDate: this.filter.startTime,
        endDate: this.filter.endTime,
        threshold: this.filter.threshold + '',
        workStationName: this.filter.workStationName,
        customerIdList: this.filter.customerIdList,
      }
      this.$emit('search', value)
    },
    async getTypeList() {
      const filter = {
        keywords: '',
        query: {
          current: 1,
          size: -1
        }
      }
      const type = await dtsp.pageDeviceType(filter)
      const list = type.records.map((res) => {
        return { key: res.id, value: res.name }
      })
      this.filter.deviceTypeId = list.map((res) => res.key)
      this.deviceTypes = list
    },
    rangeChange(value) {
      if (value && value.length) {
        this.filter.startTime = dayjs(value[0]).format('YYYY-MM-DD')
        this.filter.endTime = dayjs(value[1]).format('YYYY-MM-DD')
      }
    },
    async getTreeList() {
      const tenant = getTenantInfo()
      const tenantCode = tenant ? tenant : '根节点'
      const treeData = [
        {
          code: '00-00',
          id: undefined,
          name: tenantCode,
          isLeaf: false,
          isProv: false
        }
      ]
      const { data } = await api.getRegionCustomerDetail();
      treeData[0].children = data;
      const arr = this.getIds(data);
      this.filter.customerIdList = arr;
      this.treeData = treeData;
      this.handelSearch();
    },
    getIds(data) {
      let tmp = [];
      var fun = function (arr) {
        if(arr && arr.length>0) {
          for(let i = 0;i<arr.length; i++) {
            const item = arr[i];
            if(item.flag!==null && item.flag) {
              tmp.push(item.code);
            }
            if(item.children && item.children.length>0) {
              fun(item.children);
            }
          }
        }
      }
      fun(data);
      return tmp;
    },
    checkTree(checkedKeys, {checkedNodes}) {
      const ids = this.filterNode(checkedNodes);
      console.log(ids)
      this.filter.customerIdList = ids;
    },
    filterNode(arr) {
      if(arr.length>0) {
        return arr.flatMap(v=>{
          const item = v.data.props;
          if(item.flag) {
            return [item.code]
          }else{
            return []
          }
        });
      } else{
        return  [];
      }
    }
  }
}
</script>

<style lang="less" scoped>
.leftTreeBody {
  height: 100%;
  padding: 8px;
  min-width: 320px;
  overflow: hidden;
}
.mdc-left-tree {
  border: 1px solid #e9e9e9;
  margin-bottom: 8px;
  overflow: auto;
}
.button-save {
  position: absolute;
  width: 100%;
  text-align: right;
  left: 0;
  padding: 0 8px;
  bottom: 8px;
}
/deep/ .ant-tree li .ant-tree-treenode-checkbox-checked .ant-tree-node-content-wrapper {
  width: 100%;
  background-color: #fff1b8;
}
/deep/ .ant-tree li .ant-tree-node-content-wrapper {
  width: 100%;
}
</style>
